import { Component, OnInit, ViewChild } from "@angular/core";
import { VisiteeBatchTableComponent } from "./visitee-batch-table/visitee-batch-table.component";
import { DialogService } from "primeng/dynamicdialog";
import { MsVisiteeBatchImportComponent } from "./ms-visitee-batch-import/ms-visitee-batch-import.component";
import { VisiteeImportRequest } from "../shared/VisiteeImportRequest";
import { DataService_MultiStationVisiteeMaintenance } from "../shared/data.service";
import { MsVisiteeBatchDownloadComponent } from "./ms-visitee-batch-download/ms-visitee-batch-download.component";
import { VisiteeUpdateRequest } from "../shared/VisiteeUpdateRequest";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../../shared";
import { MsVisiteeBatchExportComponent } from "./ms-visitee-batch-export/ms-visitee-batch-export.component";

@Component({
	selector: "caass-ms-visitee-batch-mode",
	templateUrl: "./ms-visitee-batch-mode.component.html",
	styleUrls: ["./ms-visitee-batch-mode.component.css"],
})
export class MsVisiteeBatchModeComponent implements OnInit {
	constructor(
		private userService: UserService,
		private visitorService: DataService_MultiStationVisiteeMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////

	user: any;

	lstStaff: any = [];

	@ViewChild(VisiteeBatchTableComponent)
	tableRef: VisiteeBatchTableComponent;

	errorMessage: string = "";
	Processing: boolean = false;

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////
	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(MsVisiteeBatchImportComponent, {
			header: "Visitee Batch Import",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
				this.loadPerson(response[0], response[1]);
			}
		});
	}

	loadPerson(FormatOption, ImportFileData) {
		if (FormatOption == undefined || ImportFileData == undefined) {
			return;
		}

		this.Processing = true;

		let parms: VisiteeImportRequest = {
			FormatOption: FormatOption.ID,
			Base64File: ImportFileData,
		};

		var result = this.visitorService.VisiteeImportInfoSelectList(parms);
		result.subscribe(
			(response: any) => {
				console.log("Import Load Data Response");
				console.log(response);

				if (response.Success == true) {
					this.lstStaff = response.lstVisitees;
				} else {
					this.errorMessage = response.ErrorMessage;
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClearTable() {
		this.lstStaff = [];
	}

	onDownloadTable() {
		this.errorMessage = "";

		if (this.tableRef.lstStaff.length == 0) {
			this.errorMessage = "No import data to download (Import preview table is empty)";
			return;
		}

		//
		// Pick Format
		//
		var ref = this.dialogService.open(MsVisiteeBatchDownloadComponent, {
			header: "Select Format to Download",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
				this.FinishDownload(response);
			}
		});
	}

	FinishDownload(FormatOption) {
		//
		// Text, Tab delimited
		//
		if (FormatOption.ID == 1) {
			this.DownloadImportTextTab();
		}
		//
		// Text, Commas
		//
		else if (FormatOption.ID == 2) {
			this.DownloadImportTextCommas();
		}
		//
		// CSV
		//
		else if (FormatOption.ID == 3) {
			this.DownloadImportCSV();
		}
	}

	DownloadImportTextTab() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstStaff.length; z++) {
			var next = this.tableRef.lstStaff[z];

			if (next.ValidStaff == true) {
				DataStr += next.StaffID;
				DataStr += "\t";
				DataStr += String(next.Email);
				DataStr += "\t";
				DataStr += String(next.Phone);
				DataStr += "\n";
			}
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	DownloadImportTextCommas() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstStaff.length; z++) {
			var next = this.tableRef.lstStaff[z];

			if (next.ValidStaff == true) {
				DataStr += '"' + next.StaffID + '"';
				DataStr += ",";
				DataStr += '"' + String(next.Email) + '"';
				DataStr += ",";
				DataStr += '"' + String(next.Phone) + '"';
				DataStr += "\n";
			}
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	DownloadImportCSV() {
		var DataStr: string = "";

		for (var z = 0; z < this.tableRef.lstStaff.length; z++) {
			var next = this.tableRef.lstStaff[z];

			if (next.ValidStaff == true) {
				DataStr += '"' + next.StaffID + '"';
				DataStr += ",";
				DataStr += '"' + String(next.Email) + '"';
				DataStr += ",";
				DataStr += '"' + String(next.Phone) + '"';
				DataStr += "\n";
			}
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/csv," + DataStr;
		a.download = FileName + ".csv";

		this.Processing = false;

		a.click(); //Downloaded file
	}

	onExport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(MsVisiteeBatchExportComponent, {
			header: "Export",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onUpdate() {
		this.errorMessage = "";

		this.Processing = true;

		var lstPIDs: number[] = [];
		var lstVisiteeEnabled: number[] = [];
		var lstNotifyByEmail: number[] = [];
		var lstEmail: string[] = [];

		var lstNotifyByText: number[] = [];
		var lstPhone: string[] = [];

		for (var z = 0; z < this.tableRef.lstStaff.length; z++) {
			var next = this.tableRef.lstStaff[z];

			if (next.ValidStaff == true) {
				lstPIDs = [...lstPIDs, next.PersonID];
				lstVisiteeEnabled = [...lstVisiteeEnabled, 1];
				lstNotifyByEmail = [...lstNotifyByEmail, String(next.Email).trim() == "" ? 0 : 1];
				lstEmail = [...lstEmail, next.Email];

				lstNotifyByText = [...lstNotifyByText, String(next.Phone).trim() == "" ? 0 : 1];
				lstPhone = [...lstPhone, next.Phone];
			}
		}

		this.Processing = false;

		if (lstPIDs.length == 0) {
			return;
		}

		this.confirmationService.confirm({
			key: "batchconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to update " + lstPIDs.length + " visitees. Do you want to continue?",
			header: "Confirm Update Visitees",
			icon: "fa",
			accept: () => {
				// if(this.user != undefined && this.user.UserLevelID == 1){
				//   this.RemoveOthersConfirm(lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone);
				// }
				// else{
				this.FinishUpdate(0, lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone);
				// }
			},
		});
	}

	// RemoveOthersConfirm(lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone){
	//   this.confirmationService.confirm(
	//     {
	//       key: "batchremoveothers",
	//       acceptLabel: "Yes",
	//       rejectLabel: "No",
	//       rejectVisible: true,
	//       message: "Do you want to deactivate Visitees not in the import file? NOTE: This will affect the whole district",
	//       header: "Deactivate Other Visitees",
	//       icon: "fa",
	//       accept: () => {
	//         this.FinishUpdate(1, lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone);
	//       },
	//       reject: () =>{
	//         this.FinishUpdate(0, lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone);
	//       }
	//     });
	// }

	FinishUpdate(Deactivate, lstPIDs, lstVisiteeEnabled, lstNotifyByEmail, lstEmail, lstNotifyByText, lstPhone) {
		this.Processing = true;

		var parms: VisiteeUpdateRequest = {
			DeactivateNotInList: Deactivate,
			lstPersonID: lstPIDs,
			lstActive: lstVisiteeEnabled,
			lstNotifyByEmail: lstNotifyByEmail,
			lstNotifyByText: lstNotifyByText,
			lstEmail: lstEmail,
			lstPhoneNbr: lstPhone,
		};

		var result = this.visitorService.VisiteeUpdateByTable(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if ((response.Success = true)) {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "batchresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visitees imported successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "batchresult",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update visitees: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}
	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	/////////////////////////////////////////////////////////////
}
